import React from 'react';

import Box from '@mui/material/Box';

import Icon from './Icon';
import { C, FONT, APPBAR_HEIGHT } from './tokens';

// On the phone the destinations live behind the header's menu button, which opens
// the same rail the desktop shows — the pattern Hub uses. The logo still links to
// Inicio, and search keeps its own slot.
const MobileTopBar = ({ rootURL, logoURL, appName, active, onOpenNav, onOpenPalette, searchLabel }) => (
  <Box
    component="header"
    sx={{
      height: APPBAR_HEIGHT, bgcolor: C.ink, display: 'flex', alignItems: 'center', gap: '12px',
      px: '14px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: (t) => t.zIndex.appBar,
    }}
  >
    <Box
      component="button"
      onClick={onOpenNav}
      aria-label="Abrir el menú"
      sx={{
        width: 40, height: 40, flex: 'none', ml: '-8px', borderRadius: '8px',
        display: 'grid', placeItems: 'center', background: 'none', border: 0,
        color: C.railText, cursor: 'pointer',
        '&:focus-visible': { outline: `2px solid ${C.turquoise}`, outlineOffset: -2 },
      }}
    >
      <Icon name="menu" size={22} />
    </Box>

    <Box component="a" href={rootURL} sx={{ display: 'flex', flex: 'none' }}>
      <Box component="img" src={logoURL} alt={appName} sx={{ height: 18, width: 'auto', display: 'block' }} />
    </Box>

    <Box component="span" sx={{
      flex: 1, minWidth: 0, font: `600 12.5px/1 ${FONT}`, color: C.railText,
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'right',
    }}>
      {active.leafName}
    </Box>

    <Box
      component="button"
      onClick={onOpenPalette}
      aria-label={searchLabel}
      sx={{
        width: 40, height: 40, flex: 'none', borderRadius: '8px', display: 'grid', placeItems: 'center',
        background: 'none', border: 0, color: C.railText, cursor: 'pointer',
        '&:focus-visible': { outline: `2px solid ${C.turquoise}`, outlineOffset: -2 },
      }}
    >
      <Icon name="search" size={20} />
    </Box>
  </Box>
);

export default MobileTopBar;
